
<div class="mp-backdrop">
  <div class="mp-card">

    <!-- Icon + pulse ring -->
    <div class="mp-icon-wrap">
      <span class="mp-icon-pulse"></span>
      <i class="bi bi-tools mp-icon"></i>
    </div>

    <!-- Title -->
    <h2 class="mp-title">System Under Maintenance</h2>
    <p class="mp-subtitle">
      We're making improvements to deliver a better experience.<br>We'll be back shortly.
    </p>

    <div class="mp-divider"></div>

    <!-- Maintenance Window time range -->
    <div class="mp-window-info" *ngIf="window">
      <div class="mp-window-icon"><i class="bi bi-calendar3"></i></div>
      <div>
        <div class="mp-window-label">MAINTENANCE WINDOW</div>
        <div class="mp-window-time">{{ windowDateRange }}</div>
      </div>
    </div>

    <!-- ── Live Countdown Timer ─────────────────────── -->
    <div class="mp-countdown-wrap" *ngIf="!isExpired">
      <div class="mp-cd-label">ESTIMATED TIME REMAINING</div>
      <div class="mp-cd-blocks">
        <div class="mp-cd-block">
          <span class="mp-cd-num">{{ pad(countdownHours) }}</span>
          <span class="mp-cd-unit">HRS</span>
        </div>
        <span class="mp-cd-colon">:</span>
        <div class="mp-cd-block">
          <span class="mp-cd-num">{{ pad(countdownMinutes) }}</span>
          <span class="mp-cd-unit">MIN</span>
        </div>
        <span class="mp-cd-colon">:</span>
        <div class="mp-cd-block">
          <span class="mp-cd-num">{{ pad(countdownSeconds) }}</span>
          <span class="mp-cd-unit">SEC</span>
        </div>
      </div>
    </div>
    <div class="mp-countdown-expired" *ngIf="isExpired">
      <i class="bi bi-check-circle-fill"></i> Maintenance completing soon…
    </div>

    <!-- ── Progress Bar ────────────────────────────── -->
    <div class="mp-progress-section">
      <div class="mp-status-row">
        <span class="mp-status-badge">
          <span class="mp-status-dot"></span>
          In Progress
        </span>
        <span class="mp-elapsed">{{ elapsedText }}</span>
      </div>

      <div class="mp-prog-label-row">
        <span class="mp-prog-lbl">PROGRESS</span>
        <span class="mp-prog-pct">{{ progressPercent }}% Completed</span>
      </div>
      <div class="mp-prog-bar-bg">
        <div class="mp-prog-bar-fill" [style.width.%]="progressPercent">
          <span class="mp-prog-shimmer"></span>
        </div>
      </div>
    </div>

    <!-- Impact note -->
    <div class="mp-notice" *ngIf="impactNote">
      <i class="bi bi-info-circle mp-notice-icon"></i>
      <span>{{ impactNote }}</span>
    </div>

    <!-- Notify roles -->
    <div class="mp-notice mp-notice-roles" *ngIf="notifyRoles.length">
      <i class="bi bi-people mp-notice-icon"></i>
      <span>Notifying: <strong>{{ notifyRoles.join(', ') }}</strong></span>
    </div>

    <!-- Contact Support -->
    <button class="mp-btn-support">
      <i class="bi bi-headset"></i> Contact Support
    </button>

    <!-- Footer -->
    <div class="mp-footer">
      <i class="bi bi-shield-lock mp-footer-icon"></i>
      <span>We appreciate your patience. Your data is safe.</span>
    </div>

  </div>
</div>